import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Rimuove i tag HTML e decodifica le entita' (`&nbsp;`, `&#39;`, `&amp;`, ecc.)
 * per ottenere un testo pulito da usare in preview/card.
 */
export function stripHtml(html) {
  if (!html) return "";
  // 1) Togli i tag HTML
  const noTags = String(html).replace(/<[^>]*>/g, " ");
  // 2) Decodifica le entita' HTML sfruttando il parser del browser
  if (typeof document !== "undefined") {
    const el = document.createElement("textarea");
    el.innerHTML = noTags;
    return el.value.replace(/\s+/g, " ").trim();
  }
  // 3) Fallback lato SSR
  return noTags.replace(/\s+/g, " ").trim();
}
